import React from 'react';

import CardCountries from '../../components/CardCountries';

const HomePage = () => {
  return (
    <div>
      <CardCountries />
    </div>
  );
};

export default HomePage;
